function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import { updateCartCount } from "../../../utils/helpers";
var Fireworks = function Fireworks(_ref) {
  var _redux$auth$totalRewa, _redux$auth;
  var itemAdded = _ref.itemAdded,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    isPoints = _ref.isPoints;
  var fireworksInstance = useRef(null); // To hold the FireworksOverlay instance
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    cartCount = _useState2[0],
    setCartCount = _useState2[1];
  var totalRewards = (_redux$auth$totalRewa = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.totalRewards) !== null && _redux$auth$totalRewa !== void 0 ? _redux$auth$totalRewa : 0;
  var cartUpdateHandlerRef = useRef(null); // Store the handler reference

  useEffect(function () {
    // Initial count load
    // Listen for the custom 'cartUpdated' event
    updateCartCount(setCartCount, null, isPoints);

    // Create and store the handler function so we can remove it later
    var cartUpdateHandler = function cartUpdateHandler() {
      updateCartCount(setCartCount, null, isPoints);
    };
    cartUpdateHandlerRef.current = cartUpdateHandler;
    window.addEventListener("cartUpdated", cartUpdateHandler);

    // Cleanup event listener on component unmount
    return function () {
      if (cartUpdateHandlerRef.current) {
        window.removeEventListener("cartUpdated", cartUpdateHandlerRef.current);
      }
    };
  }, [isPoints]);
  useEffect(function () {
    var script;
    var timeout;
    if (itemAdded && (cartCount > 0 || totalRewards === 0)) {
      // Dynamically load the script
      script = document.createElement("script");
      script.src = "https://dadevmikey.github.io/The-Holiday-Library/NewYearsOverlay.js";
      script.async = true;
      document.body.appendChild(script);
      script.onload = function () {
        if (window.FireworksOverlay) {
          fireworksInstance.current = new window.FireworksOverlay({
            colors: ["#FF0000", "#00FF00", "#0000FF"],
            particleCount: 100,
            interval: 500
          });
          fireworksInstance.current.startAnimation();
          timeout = setTimeout(function () {
            if (fireworksInstance.current) {
              fireworksInstance.current.stopAnimation && fireworksInstance.current.stopAnimation();
              fireworksInstance.current = null;
            }
          }, 2000);
        } else {
          console.error("FireworksOverlay is not defined");
        }
      };
    } else {
      // Stop animation and clean up if itemAdded is false
      if (fireworksInstance.current) {
        fireworksInstance.current.stopAnimation && fireworksInstance.current.stopAnimation();
        fireworksInstance.current = null;
      }
    }
    return function () {
      // Cleanup on unmount
      if (fireworksInstance.current) {
        fireworksInstance.current.stopAnimation && fireworksInstance.current.stopAnimation();
        fireworksInstance.current = null;
      }
      if (script) {
        document.body.removeChild(script);
      }
      clearTimeout(timeout); // Ensure timeout is cleared on unmount
    };
  }, [itemAdded, totalRewards, cartCount]); // Re-run the effect when itemAdded changes

  return null; // This component doesn't render anything visually
};
export default Fireworks;